import { render, staticRenderFns } from "./MenuCreateOrEdit.vue?vue&type=template&id=fd3f1312&"
import script from "./MenuCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./MenuCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./MenuCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports